import React, { useContext, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Form, Button, Row, Col, Image } from 'react-bootstrap';
import { FaEdit, FaEye, FaEyeSlash, FaTrash, FaWrench } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import './Manage.scss'
import parkingBackgroundCartoon from '../../resource/img/parkingBackground.jpg'
import _ from 'lodash';
import { addListUsers, addNewAUser, deleteListUsers, deleteUser, fetchAllUsers, fetchUser, fetchUserByUserCode, updateUserInfo, fetchAvatarUser } from '../../services/adminService'
import ReactPaginate from 'react-paginate';
import { toast } from 'react-toastify';

import { AdminContext } from '../../context/AdminContext';
import faceImageDefault from '../../resource/img/MS.png'
import { convertMongoDateToInputDate } from '../../utils/utils';
import { useNavigate } from 'react-router-dom/dist';
import { useDispatch, useSelector } from 'react-redux';




const ListClients = (props) => {


    const admin = useSelector(state => state.admin)
    const dispatch = useDispatch()

    let validInputDefault = {
        userCode: true,
        name: true,
        gender: true,
        phoneNumber: true,
        email: true,
        faceImage: true
    }

    let validInputEditDefault = {
        userCode: true,
        name: true,
        phoneNumber: true,
        email: true,
        gender: true,
        dateOfBirth: true,
        address: true,
        password: true,
        repassword: true,
        faceImage: true,
    }

    let defaultDataToAdd = {
        userCode: '',
        name: '',
        gender: '',
        phoneNumber: '',
        email: '',
        accountPassword: '123123123',
        faceImage: null
    }

    let defaultDataToEdit = {
        userCode: '',
        name: '',
        phoneNumber: '',
        email: '',
        gender: '',
        dateOfBirth: '',
        address: '',
        password: '',
        repassword: '',
        faceImage: null,
    }

    let navigate = useNavigate()

    const [password, setPassword] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [confirmDelete, setShowConfirmdelete] = useState(false);
    const [isSaveDisabled, setIsSaveDisabled] = useState(true)
    const [userData, setUserData] = useState(defaultDataToAdd)
    const [validInput, setValidInput] = useState(validInputDefault)
    const fileInputRef = useRef(null)
    const [fileUsers, setFileUsers] = useState()
    const [faceImageAdd, setFaceIamgeAdd] = useState("")
    const [faceImageView, setFaceImageView] = useState("")

    //state edit
    const [dataBeforeEdit, setDataBeforeEdit] = useState({})
    const [dataDetail, setDataDetail] = useState({})
    const [userDataEdit, setUserDataEdit] = useState(defaultDataToEdit)
    const [validInputEdit, setValidInputEdit] = useState(validInputEditDefault)
    const [isSaveEditDisabled, setIsSaveEditDisabled] = useState(true)
    const [showPassword, setShowPassword] = useState(false)
    const [showRePassword, setShowRePassword] = useState(false)
    const [faceImageEditShow, setFaceImageEditShow] = useState("../../resource/img/MS.png")


    //state delete
    const [listUsersToDelete, setListUsersToDelete] = useState([])
    const [checkedItems, setCheckedItems] = useState({});

    //state find
    const [userCodeToFind, setUserCodeToFind] = useState('')


    //state pagination
    const [currentPage, setCurrentPage] = useState(1)
    const [currentLimit, setCurrentLimit] = useState(10)
    const [listUsers, setListUsers] = useState([])
    const [totalPages, setTotalPages] = useState(0)


    const handleAddUserToListToDelete = (userCode, dataUser) => {
        const isChecked = !checkedItems[userCode];
        setCheckedItems(prevCheckedItems => ({
            ...prevCheckedItems,
            [userCode]: isChecked
        }));

        if (isChecked) {
            setListUsersToDelete(prevSelectedUsers => [...prevSelectedUsers, dataUser]);
        } else {
            setListUsersToDelete(prevSelectedUsers => prevSelectedUsers.filter(user => user.userCode !== userCode));
        }
    };


    const handleOnchangeInput = (value, name) => {
        if (name === 'faceImage') {
            const reader = new FileReader()
            reader.onloadend = () => {
                setFaceIamgeAdd(reader.result)
            }
            reader.readAsDataURL(value)
        }
        let _userData = _.cloneDeep(userData)
        _userData[name] = value
        setUserData(_userData)


        if (_userData.userCode === '' && _userData.name === '' && _userData.gender === '' && _userData.phoneNumber === '' && _userData.email === '' && _userData.faceImage === '')
            setIsSaveDisabled(true)
        else
            setIsSaveDisabled(false)
    }

    const handleOnchangeInputEdit = (value, name) => {
        console.log('name: ', name);
        if (name === 'faceImage') {
            const reader = new FileReader()
            console.log('runed');
            reader.onloadend = () => {
                console.log('faceAvt url:', reader.result);
                setFaceImageEditShow(reader.result)
            }
            reader.readAsDataURL(value)
        }
        let _userDataEdit = _.cloneDeep(userDataEdit)
        _userDataEdit[name] = value
        setUserDataEdit(_userDataEdit)
        console.log('editData: ', _userDataEdit);
        //if(_userDataEdit.userCode === '' && _userDataEdit.name == '' && _userDataEdit.phoneNumber === '' && _userDataEdit.email === '' && ) 
        if (_userDataEdit === defaultDataToEdit) {
            setIsSaveEditDisabled(true)
        } else {
            setIsSaveEditDisabled(false)
        }

    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    const toggleRePasswordVisibility = () => {
        setShowRePassword(!showRePassword)
    }

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const isEmptyInputEdit = () => {
        setValidInputEdit(validInputEditDefault)
        let field = ['userCode', 'name', 'phoneNumber', 'email', 'gender', 'dateOfBirth', 'address', 'password', 'repassword',]
        let check = true;
        for (let i = 0; i < field.length; i++) {
            if (!userDataEdit[field[i]]) {
                let _validInputEdit = _.cloneDeep(validInputEditDefault)
                _validInputEdit[field[i]] = false
                setValidInputEdit(_validInputEdit)
                toast.error(`${field[i]} is empty.`)
                check = false;
                break;
            }
        }
        return check;
    }

    let isAldult = (birthDateString) => {
        // Chuyển chuỗi ngày thành đối tượng Date
        const birthDate = new Date(birthDateString);

        // Lấy ngày hiện tại
        const today = new Date();

        // Lấy năm, tháng, ngày từ ngày sinh
        const birthYear = birthDate.getFullYear();
        const birthMonth = birthDate.getMonth();
        const birthDay = birthDate.getDate();

        // Tính tuổi
        let age = today.getFullYear() - birthYear;

        // Kiểm tra xem đã qua sinh nhật năm nay chưa
        const hasHadBirthdayThisYear = today.getMonth() > birthMonth ||
            (today.getMonth() === birthMonth && today.getDate() >= birthDay);

        // Nếu chưa qua sinh nhật năm nay thì giảm tuổi đi 1
        if (!hasHadBirthdayThisYear) {
            age--;
        }

        // Kiểm tra tuổi có đủ 18 không
        return age >= 18;
    }


    let isValidValueEdit = () => {
        const regexCode = /^\d{8}$/
        // const regexFullName = 
        const regexPhone = /^0\d{9}$/
        const regexEmail = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{5,16}@gmail\.com$/;
        const regexPwd = /^[\s\S]{7,16}$/;

        if (regexCode.test(userDataEdit['userCode']) === false) {
            toast.error('Mã không hợp lệ.')
            setValidInputEdit({ ...validInputEditDefault, userCode: false })
            return false;
        } else {
            setValidInputEdit({ ...validInputEditDefault, userCode: true })
        }

        if (regexPhone.test(userDataEdit['phoneNumber']) === false) {
            toast.error('Số điện thoại không hợp lệ.')
            setValidInputEdit({ ...validInputEditDefault, phoneNumber: false })
            return false;
        } else {
            setValidInputEdit({ ...validInputEditDefault, phoneNumber: true })
        }


        if (regexEmail.test(userDataEdit['email']) === false) {
            toast.error('Email không hợp lệ.')
            setValidInputEdit({ ...validInputEditDefault, email: false })
            return false;
        } else {
            setValidInputEdit({ ...validInputEditDefault, email: true })
        }



        if (userDataEdit['gender'] === '') {
            toast.error('Không được bỏ trống')
            setValidInputEdit({ ...validInputEditDefault, gender: false })
            return false
        } else {
            setValidInputEdit({ ...validInputEditDefault, gender: true })
        }


        if (!isAldult(userDataEdit['dateOfBirth'])) {
            toast.error('Bạn phải đủ 18 tuổi trở lên để sử dụng dịch vụ này.')
            setValidInputEdit({ ...validInputEditDefault, dateOfBirth: false })
            return false
        } else {
            setValidInputEdit({ ...validInputEditDefault, dateOfBirth: true })
        }


        if (regexPwd.test(userDataEdit['password']) === false) {
            toast.error('Mật khẩu không hợp lệ.')
            setValidInputEdit({ ...validInputEditDefault, password: false })
            return false;
        } else {
            setValidInputEdit({ ...validInputEditDefault, password: true })
        }


        if (userDataEdit['password'] !== userDataEdit['repassword']) {
            toast.error('Mật khẩu không khớp.')
            setValidInputEdit({ ...validInputEditDefault, password: false, repassword: false })
            return false;
        } else {
            setValidInputEdit({ ...validInputEditDefault, password: true, repassword: true })
        }


        return true;
    }



    //add

    const isEmptyInput = () => {
        setValidInput(validInputDefault)
        let field = ['userCode', 'name', 'gender', 'phoneNumber', 'email', 'faceImage']
        let check = true;
        for (let i = 0; i < field.length; i++) {
            if (!userData[field[i]]) {
                let _validInput = _.cloneDeep(validInputDefault)
                _validInput[field[i]] = false
                setValidInput(_validInput)
                toast.error(`${field[i]} is empty.`)
                check = false;
                break;
            }
        }
        return check;
    }

    let isValidValue = () => {
        // const regexCode = /^\d{8}$/
        // const regexFullName = 
        const regexPhone = /^0\d{9}$/
        const regexEmail = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{5,16}@gmail\.com$/;

        // if (regexCode.test(userData['userCode']) === false) {
        //     toast.error('Mã không hợp lệ.')
        //     setValidInput({ ...validInputDefault, userCode: false })
        //     return false;
        //     // }else if(userData['userCode'] === ''){
        //     //     toast.error('Không được bỏ trống.')
        //     //     setValidInput({...validInputDefault, userCode: false})
        //     //     return false;
        // } else {
        //     setValidInput({ ...validInputDefault, userCode: true })
        // }

        setValidInput({ ...validInputDefault, userCode: true })

        // if(userData['name'] === ''){
        //     toast.error('Không được bỏ trống.')
        //     setValidInput({...validInputDefault, name: false})
        //     return false
        // }else{
        //     setValidInput({...validInputDefault, name: true})
        // }

        if (userData['gender'] === '') {
            toast.error('Không được bỏ trống')
            setValidInput({ ...validInputDefault, gender: false })
            return false
        } else {
            setValidInput({ ...validInputDefault, gender: true })
        }

        if (regexPhone.test(userData['phoneNumber']) === false) {
            toast.error('Số điện thoại không hợp lệ.')
            setValidInput({ ...validInputDefault, phoneNumber: false })
            return false;
            // }else if(userData['phoneNumber'] === ''){
            //     toast.error('Không được bỏ trống.')
            //     setValidInput({...validInputDefault, phoneNumber: false})
            //     return false;
        } else {
            setValidInput({ ...validInputDefault, phoneNumber: true })
        }


        if (regexEmail.test(userData['email']) === false) {
            toast.error('Email không hợp lệ.')
            setValidInput({ ...validInputDefault, email: false })
            return false;
            // }else if(userData['email'] === ''){
            //     toast.error('Không được bỏ trống.')
            //     setValidInput({...validInputDefault, email: false})
            //     return false;
        } else {
            setValidInput({ ...validInputDefault, email: true })
        }

        return true;
    }

    //handle event


    const handleAddUser = async () => {
        let check = isEmptyInput() && isValidValue()
        if (check) {
            console.log('check data to add: ', userData);
            //setShowAddModal(false); // Close the modal after action
            //setUserData(defaultDataToAdd)
            const formData = new FormData()
            formData.append('userCode', userData.userCode)
            formData.append('name', userData.name)
            formData.append('gender', userData.gender)
            formData.append('phoneNumber', userData.phoneNumber)
            formData.append('email', userData.email)
            formData.append('accountPassword', userData.accountPassword)
            formData.append('faceImage', userData.faceImage)
            console.log('formData: \n');
            for (let [key, value] of formData.entries()) {
                console.log(key, " : ", value);
            }
            let response = await addNewAUser(formData)
            if (response && response.ok) {
                toast.success(response.message)
                setShowAddModal(false)
                setUserData(defaultDataToAdd)
                setFaceIamgeAdd("")
                await fetchListUsers()
            } else {
                toast.error(response.message)
            }
        }
    };

    const handleAddListUsers = async () => {
        // const fileInput = fileInputRef.current;
        // if (!fileInput || !fileInput.files.length) {
        //     toast.error('Hãy chọn file thích hợp.')
        //     return;
        // }

        const formData = new FormData()
        formData.append('file', fileUsers)
        let response = await addListUsers(formData)
        console.log('run here');
        console.log('response: ', response);
        if (response && response.ok) {
            toast.success(response.message)
            setShowAddModal(false)
            setFileUsers(null)
            await fetchListUsers()
        } else {
            console.log('run else');
            console.log('response.ok', response);
            toast.error(response.message)
        }
    }

    const handleEditUser = async () => {
        let check = isEmptyInputEdit() && isValidValueEdit()
        let data = userDataEdit
        if (check) {
            console.log('data to edit: ', data);
            console.log('userCode old: ', dataDetail.userCode);
            let response = await updateUserInfo(data, dataDetail.userCode)
            if (response && response.ok) {
                toast.success(response.message)
                setShowEditModal(false)
                setUserDataEdit(defaultDataToEdit)
                await fetchListUsers()
            } else {
                toast.error(response.message)
            }
        }
    }

    const handleDeleteAUser = async (data) => {
        console.log('data to delete: ', data);
        let response = await deleteUser(data)
        if (response && response.ok) {
            toast.success(response.message)
            setShowConfirmdelete(false)
            await fetchListUsers()
        } else {
            toast.error(response.message)
        }
        // Close the modal after action
    };

    const handleDeleteListUsers = async () => {
        console.log('listUser to delete: ', listUsersToDelete);
        console.log('password to confirm admin to delete: ', password);
        let adminCode = admin.adminData.adminCode
        let response = await deleteListUsers({ listUsersToDelete, password, adminCode })
        if (response && response.ok) {
            console.log('list isCHecked: ', checkedItems);
            toast.success(response.message)
            setShowDeleteModal(false);
            setListUsersToDelete([])
            setPassword("")
            await fetchListUsers()
        } else {
            toast.error(response.message)
        }
    }

    const handlePageClick = (event) => {
        setCurrentPage(+event.selected + 1)
    }

    const handleFindUserByUserCode = async (userCode) => {
        console.log('userCode to find: ', userCode);
        let response = await fetchUserByUserCode(userCode, 1, 10)
        console.log('response.data: ', response.data);
        if (response && response.ok) {
            toast.info(response.message)
            setTotalPages(response.data.totalPage)
            setListUsers(response.data.dataUsers)
        }
    }

    //fetch data
    const fetchListUsers = async () => {
        console.log('currenpage: ', currentPage, '. current limit: ', currentLimit);
        let response = await fetchAllUsers(currentPage, currentLimit)
        console.log('listUser: ', response.data.dataUsers);
        if (response && response.ok) {
            setTotalPages(response.data.totalPage)
            setListUsers(response.data.dataUsers)
        }


        //
        const initialCheckedItems = response.data.dataUsers.reduce((acc, user) => {
            acc[user.userCode] = listUsersToDelete.some(u => u.userCode === user.userCode);
            return acc;
        }, {});
        setCheckedItems(initialCheckedItems);


    }

    const fetchDataUser = async (userCode) => {
        let response = await fetchUser(userCode)
        if (response) {
            setDataDetail(response.data)
            return response.data
        }
    }

    const fetchImageUser = async (faceAvatarFileName) => {
        let response = await fetchAvatarUser(faceAvatarFileName)
        return response?.data?.DT || null
    }


    //action: show detail, edit, delete
    const handleShowDetailModal = async (data) => {
        let dataDetailModal = await fetchDataUser(data.userCode)
        setShowDetailModal(true)
        const imagePublicId = dataDetailModal?.faceImage?.fileName
        const imageUrl = dataDetailModal?.faceImage?.imageUrl
            || (imagePublicId ? await fetchImageUser(imagePublicId) : null)
        setFaceImageView(imageUrl || null)
    }

    const handleShowDeleteModal = async (data) => {
        await fetchDataUser(data.userCode)
        setShowConfirmdelete(true)
    }

    useEffect(() => {
        fetchListUsers()
        console.log('admin info: ', admin);
        // console.log('listUser: ', listUsers);
    }, [currentPage])


    // useEffect(() => {
    //     // Reset checked items when listUsers is updated
    //     setCheckedItems({});
    //   }, [listUsers]);


    return (
        <div className="user-management-container">
            <Helmet>
                <title>Quản lý người dùng - Hệ thống bãi giữ xe</title>
            </Helmet>

            <div className="container">
                <div className="main-content">
                    {/* Page Header */}
                    <div className="page-header">
                        <h3 className="d-flex align-items-center gap-2">
                            <i className="bi bi-people-fill text-primary"></i>
                            Quản lý người dùng
                        </h3>
                        <p className="subtitle">Quản lý thông tin và quyền truy cập của người dùng hệ thống</p>
                    </div>

                    {/* Controls Section */}
                    <div className="controls-section">
                        {/* Search Controls */}
                        <div className="search-controls">
                            <div className="row align-items-center g-2">
                                <div className="col-md-8">
                                    <div className="search-input-group">
                                        <input
                                            type="text"
                                            className="form-control search-input"
                                            placeholder="Nhập mã người dùng để tìm kiếm..."
                                            value={userCodeToFind}
                                            onChange={(event) => setUserCodeToFind(event.target.value)}
                                        />
                                        <i className="bi bi-search search-icon"></i>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="search-buttons d-flex gap-2">
                                        <Button
                                            variant="primary"
                                            className="rounded-3 px-3 py-2 fw-medium d-flex align-items-center gap-2"
                                            onClick={() => handleFindUserByUserCode(userCodeToFind)}
                                        >
                                            <i className="bi bi-search"></i>
                                            <span>Tìm kiếm</span>
                                        </Button>
                                        <Button
                                            variant="light"
                                            className="border rounded-3 px-3 py-2 fw-medium text-secondary d-flex align-items-center gap-2"
                                            onClick={() => fetchListUsers()}
                                        >
                                            <i className="bi bi-x-lg"></i>
                                            <span>Hủy</span>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                                <h6 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
                                    <i className="bi bi-people-fill text-primary fs-5"></i>
                                    Danh sách người dùng ({listUsers.length})
                                </h6>
                            </div>
                            <div className="action-buttons d-flex gap-2">
                                <Button
                                    variant="primary"
                                    className="rounded-3 px-3 py-2 fw-semibold d-flex align-items-center gap-2"
                                    onClick={() => setShowAddModal(true)}
                                >
                                    <i className="bi bi-plus-lg"></i>
                                    <span>Thêm người dùng</span>
                                </Button>
                                <Button
                                    variant="outline-danger"
                                    className="rounded-3 px-3 py-2 fw-semibold d-flex align-items-center gap-2"
                                    onClick={() => setShowDeleteModal(true)}
                                    disabled={listUsersToDelete.length === 0}
                                >
                                    <i className="bi bi-trash3"></i>
                                    <span>Xóa ({listUsersToDelete.length})</span>
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="table-responsive">
                        <table className="table modern-table mb-0">
                            <thead>
                                <tr>
                                    <th width="50">
                                        <div className="custom-checkbox">
                                            <input
                                                type="checkbox"
                                                id="selectAll"
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    const newCheckedItems = {};
                                                    const newSelectedUsers = [];

                                                    listUsers.forEach(user => {
                                                        newCheckedItems[user.userCode] = isChecked;
                                                        if (isChecked) {
                                                            newSelectedUsers.push(user);
                                                        }
                                                    });

                                                    setCheckedItems(newCheckedItems);
                                                    setListUsersToDelete(newSelectedUsers);
                                                }}
                                            />
                                        </div>
                                    </th>
                                    <th>STT</th>
                                    <th>Mã người dùng</th>
                                    <th>Họ tên</th>
                                    <th>Giới tính</th>
                                    <th>Chức vụ</th>
                                    <th width="120">Thao tác</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listUsers && listUsers.length > 0 ? (
                                    listUsers.map((item, index) => (
                                        <tr key={`user-${item.userCode}-${index}`}>
                                            <td>
                                                <div className="custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        id={`checkbox-${item.userCode}`}
                                                        checked={checkedItems[item.userCode] || false}
                                                        onChange={() => handleAddUserToListToDelete(item.userCode, item)}
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <span className="fw-medium text-secondary">{index + 1}</span>
                                            </td>
                                            <td>
                                                <span className="user-code">{item?.userCode}</span>
                                            </td>
                                            <td>
                                                <span className="user-name">
                                                    {item?.userDetail?.name || 'Không có tên'}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={`gender-badge ${item?.userDetail?.gender ? 'male' : 'female'}`}>
                                                    {item?.userDetail?.gender ? 'Nam' : 'Nữ'}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="role-badge">
                                                    {item?.userDetail?.role || 'Người dùng'}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="action-buttons d-flex gap-1">
                                                    <button
                                                        className="btn btn-sm btn-light border text-success rounded-2 p-1.5"
                                                        onClick={() => handleShowDetailModal(item)}
                                                        title="Xem chi tiết"
                                                    >
                                                        <i className="bi bi-eye"></i>
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-light border text-danger rounded-2 p-1.5"
                                                        onClick={() => handleShowDeleteModal(item)}
                                                        title="Xóa người dùng"
                                                    >
                                                        <i className="bi bi-trash3"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7} className="text-center py-5">
                                            <div className="empty-state">
                                                <i className="fas fa-users fa-3x text-muted mb-3"></i>
                                                <h5 className="text-muted">Không có dữ liệu</h5>
                                                <p className="text-muted">Chưa có người dùng nào trong hệ thống</p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    {totalPages > 0 && (
                        <div className='user-footer'>
                            <ReactPaginate
                                nextLabel={<><i className="fas fa-chevron-right"></i> Sau</>}
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={2}
                                pageCount={totalPages}
                                previousLabel={<>Trước <i className="fas fa-chevron-left"></i></>}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                            />
                        </div>
                    )}
                </div>
            </div>
            {/* Modal view info */}
            <Modal
                size='xl'
                show={showDetailModal && dataDetail}
                onHide={() => setShowDetailModal(false)}
                centered
                className="modern-user-detail-modal"
            >
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fw-bold fs-6 text-dark d-flex align-items-center gap-2">
                        <i className="bi bi-person-bounding-box text-primary fs-5"></i>
                        Thông tin chi tiết người dùng
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Row className="g-4">
                        <Col lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-card-heading text-primary"></i> Mã người dùng
                                </Form.Label>
                                <Form.Control type="text" className="fw-bold font-monospace bg-light" value={dataDetail.userCode || ''} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-person-fill text-primary"></i> Họ tên
                                </Form.Label>
                                <Form.Control type="text" className="fw-semibold bg-light" value={dataDetail.name || ''} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-telephone-fill text-primary"></i> Số điện thoại
                                </Form.Label>
                                <Form.Control type="text" className="bg-light" value={dataDetail.phoneNumber || 'Chưa cập nhật'} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-envelope-fill text-primary"></i> Email
                                </Form.Label>
                                <Form.Control type="text" className="bg-light" value={dataDetail.email || 'Chưa cập nhật'} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-gender-ambiguous text-primary"></i> Giới tính
                                </Form.Label>
                                <Form.Control type="text" className="bg-light" value={dataDetail.gender === true || dataDetail.gender === 'Nam' ? 'Nam' : 'Nữ'} readOnly />
                            </Form.Group>

                            <div className="pt-2">
                                <Form.Label className="small text-secondary fw-semibold d-block mb-2">Xem thêm dịch vụ tài khoản:</Form.Label>
                                <div className="d-flex gap-2 flex-wrap">
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        className="rounded-2 fw-medium d-flex align-items-center gap-2"
                                        onClick={() => {
                                            const vehicles = dataDetail.vehicles || dataDetail.Vehicles || [];
                                            if (vehicles && vehicles.length > 0) {
                                                const plates = vehicles.map(v => v.licensePlate || v.plateNumber || 'Xe chưa đăng ký biển').join(', ');
                                                toast.info(`Phương tiện đã đăng ký: ${plates}`);
                                            } else {
                                                toast.info(`Người dùng ${dataDetail.name || dataDetail.userCode} chưa đăng ký phương tiện.`);
                                            }
                                        }}
                                    >
                                        <i className="bi bi-car-front-fill"></i> Thông tin phương tiện
                                    </Button>
                                    <Button
                                        variant="outline-success"
                                        size="sm"
                                        className="rounded-2 fw-medium d-flex align-items-center gap-2"
                                        onClick={() => {
                                            const balance = dataDetail.eWallet?.balance ?? dataDetail.balance ?? 0;
                                            toast.info(`Ví điện tử [${dataDetail.userCode}]: ${balance.toLocaleString('vi-VN')} VNĐ`);
                                        }}
                                    >
                                        <i className="bi bi-wallet2"></i> Thông tin ví điện tử
                                    </Button>
                                </div>
                            </div>
                        </Col>

                        <Col lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-calendar-event text-primary"></i> Ngày sinh
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    className="bg-light"
                                    value={
                                        dataDetail.dateOfBirth
                                            ? (() => {
                                                try {
                                                    const d = new Date(dataDetail.dateOfBirth);
                                                    return isNaN(d.getTime()) ? dataDetail.dateOfBirth : d.toLocaleDateString('vi-VN');
                                                } catch {
                                                    return dataDetail.dateOfBirth;
                                                }
                                            })()
                                            : 'Chưa cập nhật'
                                    }
                                    readOnly
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-geo-alt-fill text-primary"></i> Địa chỉ
                                </Form.Label>
                                <Form.Control type="text" className="bg-light" value={dataDetail.address || 'TP. Hồ Chí Minh'} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-image text-primary"></i> Ảnh đại diện
                                </Form.Label>
                                <div className="border rounded-3 p-3 bg-light text-center d-flex align-items-center justify-content-center" style={{ minHeight: "200px" }}>
                                    {dataDetail.faceImage?.imageUrl || (typeof dataDetail.faceImage === 'string' && dataDetail.faceImage.startsWith('http')) ? (
                                        <Image
                                            src={dataDetail.faceImage?.imageUrl || dataDetail.faceImage}
                                            style={{ maxHeight: '180px', maxWidth: '100%', objectFit: 'contain' }}
                                            className="rounded-3 shadow-sm"
                                            alt="Avatar"
                                            onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                                        />
                                    ) : null}
                                    <div
                                        className="avatar-fallback flex-column align-items-center justify-content-center"
                                        style={{ display: (dataDetail.faceImage?.imageUrl || (typeof dataDetail.faceImage === 'string' && dataDetail.faceImage.startsWith('http'))) ? 'none' : 'flex' }}
                                    >
                                        <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center fw-bold fs-3 mb-2 shadow-sm" style={{ width: '64px', height: '64px' }}>
                                            {(dataDetail.name || 'U').charAt(0).toUpperCase()}
                                        </div>
                                        <span className="text-secondary small fw-medium">Chưa có ảnh đại diện</span>
                                    </div>
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" className="rounded-2 px-3 fw-medium" onClick={() => setShowDetailModal(false)}>
                        <i className="bi bi-x-lg me-1"></i> Đóng
                    </Button>
                    <Button
                        variant="primary"
                        className="rounded-2 px-4 fw-bold shadow-sm"
                        onClick={() => {
                            setShowEditModal(true);
                            setShowDetailModal(false);
                            setDataBeforeEdit(dataDetail);
                        }}
                    >
                        <i className="bi bi-pencil-square me-1"></i> Chỉnh sửa thông tin
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Edit user info */}
            <Modal
                size="xl"
                show={showEditModal && dataDetail}
                onHide={() => { setShowEditModal(false); setDataBeforeEdit({}) }}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Chỉnh sửa thông tin
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-6'>
                            <div className="form-group">
                                <Form.Label>Mã người dùng</Form.Label>
                                <input type="text" defaultValue={dataBeforeEdit.userCode} className={validInputEdit.userCode === true ? 'form-control' : 'form-control is-invalid'} onChange={(event) => handleOnchangeInputEdit(event.target.value, 'userCode')} />
                            </div>
                            <div className="form-group">
                                <Form.Label>Họ tên</Form.Label>
                                <input type="text" defaultValue={dataBeforeEdit.name} className={validInputEdit.name === true ? 'form-control' : 'form-control is-invalid'} onChange={(event) => handleOnchangeInputEdit(event.target.value, 'name')} />
                            </div>
                            <div className="form-group">
                                <Form.Label>Số điện thoại</Form.Label>
                                <input type="text" defaultValue={dataBeforeEdit.phoneNumber} className={validInputEdit.phoneNumber === true ? 'form-control' : 'form-control is-invalid'} onChange={(event) => handleOnchangeInputEdit(event.target.value, 'phoneNumber')} />
                            </div>
                            <div className="form-group">
                                <Form.Label>Email</Form.Label>
                                <input type="email" defaultValue={dataBeforeEdit.email} className={validInputEdit.email === true ? 'form-control' : 'form-control is-invalid'} onChange={(event) => handleOnchangeInputEdit(event.target.value, 'email')} />
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className="form-group">
                                <Form.Label style={{ marginRight: '15%' }}>Giới tính</Form.Label><br />
                                <Form.Check // prettier-ignore
                                    inline
                                    type={'radio'}
                                    // id={`default-${type}`}
                                    name='gender'
                                    value={'Nam'}
                                    label={'Nam'}
                                    checked={dataBeforeEdit.gender === true}
                                    onClick={(event) => handleOnchangeInputEdit(event.target.value, "gender")}
                                />
                                <Form.Check // prettier-ignore
                                    inline
                                    type={'radio'}
                                    // id={`default-${type}`}
                                    name='gender'
                                    value={'Nữ'}
                                    label={'Nữ'}
                                    checked={dataBeforeEdit.gender === false}
                                    onClick={(event) => handleOnchangeInputEdit(event.target.value, "gender")}
                                />
                                <br />
                                {validInputEdit.gender === true ? <></> : <span className='err' style={{ color: 'red', fontStyle: 'italic' }}>Hãy chọn giới tính.</span>}
                                <br />
                            </div>
                            <div className="form-group">
                                <Form.Label>Ngày sinh: </Form.Label>
                                <input type="date" defaultValue={convertMongoDateToInputDate(new Date(dataBeforeEdit.dateOfBirth))} className={validInputEdit.dateOfBirth === true ? 'form-control' : 'form-control is-invalid'} onChange={(event) => handleOnchangeInputEdit(event.target.value, 'dateOfBirth')} />
                            </div>
                            <div className="form-group">
                                <Form.Label>Địa chỉ: </Form.Label>
                                <input type="text" defaultValue={dataBeforeEdit.address} className={validInputEdit.address === true ? 'form-control' : 'form-control is-invalid'} onChange={(event) => handleOnchangeInputEdit(event.target.value, 'address')} />
                            </div>
                            <div className="form-group">
                                <Form.Label>Mật khẩu: </Form.Label>
                                <div className='d-flex'>
                                    <input type={showPassword ? 'text' : 'password'} className={validInputEdit.password === true ? 'form-control' : 'form-control is-invalid'} onChange={(event) => handleOnchangeInputEdit(event.target.value, 'password')} />
                                    <Button
                                        className="password-toggle-btn"
                                        onClick={togglePasswordVisibility}
                                        style={{ marginLeft: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', borderStyle: "solid" }}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </Button>
                                </div>
                            </div>
                            <div className="form-group">
                                <Form.Label>Nhập lại mật khẩu: </Form.Label>
                                <div className='d-flex'>
                                    <input type={showRePassword ? 'text' : 'password'} className={validInputEdit.repassword === true ? 'form-control' : 'form-control is-invalid'} onChange={(event) => handleOnchangeInputEdit(event.target.value, 'repassword')} />
                                    <Button
                                        className="password-toggle-btn"
                                        onClick={toggleRePasswordVisibility}
                                        style={{ marginLeft: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', borderStyle: "solid" }}
                                    >
                                        {showRePassword ? <FaEyeSlash /> : <FaEye />}
                                    </Button>
                                </div>
                            </div>
                            <div className='form-group'>
                                <Form.Label>Ảnh đại diện</Form.Label>
                                <Col sm={9}>
                                    <div style={{
                                        width: '50%',
                                        height: '240px',
                                        border: 'solid',
                                        overflow: 'hidden',
                                        position: 'relative',
                                        color: "black",
                                    }}>
                                        <Image src={dataBeforeEdit?.faceImage || faceImageEditShow} style={{ width: '100%', height: 'auto' }} alt="image" />
                                    </div>
                                </Col>
                                <input type='file' defaultValue={dataBeforeEdit?.faceImage} onChange={(event) => handleOnchangeInputEdit(event.target.files[0], 'faceImage')}></input>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Hủy
                    </Button>
                    <Button variant="primary" onClick={() => handleEditUser()} disabled={isSaveEditDisabled}>
                        Lưu
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Add User Modal */}
            <Modal show={showAddModal} onHide={() => { setShowAddModal(false); setFaceIamgeAdd("") }} size="lg" centered dialogClassName="add-user-modal">
                <Modal.Header closeButton className="bg-light border-bottom py-3 px-4">
                    <Modal.Title className="fw-bold fs-5 text-dark d-flex align-items-center gap-2">
                        <i className="bi bi-person-plus-fill text-primary fs-4"></i>
                        Thêm người dùng mới
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <div className="row g-3">
                        {/* Cột trái: Thông tin cá nhân */}
                        <div className="col-md-6">
                            <div className="mb-3">
                                <Form.Label className="fw-semibold small text-secondary">
                                    <i className="bi bi-person-vcard me-2 text-primary"></i>Mã người dùng <span className="text-danger">*</span>
                                </Form.Label>
                                <input
                                    type="text"
                                    className={validInput.userCode === true ? 'form-control rounded-3' : 'form-control rounded-3 is-invalid'}
                                    placeholder="Nhập mã người dùng (8 chữ số)"
                                    onChange={(event) => handleOnchangeInput(event.target.value, "userCode")}
                                />
                            </div>

                            <div className="mb-3">
                                <Form.Label className="fw-semibold small text-secondary">
                                    <i className="bi bi-person-fill me-2 text-primary"></i>Họ tên <span className="text-danger">*</span>
                                </Form.Label>
                                <input
                                    type="text"
                                    className={validInput.name === true ? 'form-control rounded-3' : 'form-control rounded-3 is-invalid'}
                                    placeholder="Nhập họ và tên"
                                    onChange={(event) => handleOnchangeInput(event.target.value, "name")}
                                />
                            </div>

                            <div className="mb-3">
                                <Form.Label className="fw-semibold small text-secondary">
                                    <i className="bi bi-telephone-fill me-2 text-primary"></i>Số điện thoại <span className="text-danger">*</span>
                                </Form.Label>
                                <input
                                    type="text"
                                    className={validInput.phoneNumber === true ? 'form-control rounded-3' : 'form-control rounded-3 is-invalid'}
                                    placeholder="Nhập số điện thoại"
                                    onChange={(event) => handleOnchangeInput(event.target.value, "phoneNumber")}
                                />
                            </div>

                            <div className="mb-3">
                                <Form.Label className="fw-semibold small text-secondary">
                                    <i className="bi bi-envelope-fill me-2 text-primary"></i>Email <span className="text-danger">*</span>
                                </Form.Label>
                                <input
                                    type="email"
                                    className={validInput.email === true ? 'form-control rounded-3' : 'form-control rounded-3 is-invalid'}
                                    placeholder="example@gmail.com"
                                    onChange={(event) => handleOnchangeInput(event.target.value, "email")}
                                />
                            </div>
                        </div>

                        {/* Cột phải: Giới tính & Ảnh đại diện */}
                        <div className="col-md-6">
                            <div className="mb-3">
                                <Form.Label className="fw-semibold small text-secondary mb-2">
                                    <i className="bi bi-gender-ambiguous me-2 text-primary"></i>Giới tính <span className="text-danger">*</span>
                                </Form.Label>
                                <div className="d-flex gap-3 bg-light p-2 rounded-3 border">
                                    <Form.Check
                                        type="radio"
                                        name="gender"
                                        id="gender-nam"
                                        value="Nam"
                                        label="Nam"
                                        className="fw-semibold"
                                        onClick={(event) => handleOnchangeInput(event.target.value, "gender")}
                                    />
                                    <Form.Check
                                        type="radio"
                                        name="gender"
                                        id="gender-nu"
                                        value="Nữ"
                                        label="Nữ"
                                        className="fw-semibold"
                                        onClick={(event) => handleOnchangeInput(event.target.value, "gender")}
                                    />
                                </div>
                                {validInput.gender === false &&
                                    <small className="text-danger mt-1 d-block">Hãy chọn giới tính.</small>
                                }
                            </div>

                            <div className="mb-3">
                                <Form.Label className="fw-semibold small text-secondary mb-2">
                                    <i className="bi bi-camera-fill me-2 text-primary"></i>Ảnh đại diện <span className="text-danger">*</span>
                                </Form.Label>
                                <div className="avatar-upload-box d-flex align-items-center justify-content-center mb-2">
                                    {faceImageAdd ? (
                                        <Image
                                            src={faceImageAdd}
                                            className="w-100 h-100 rounded-3"
                                            style={{ objectFit: 'cover' }}
                                            alt="Preview"
                                        />
                                    ) : (
                                        <div className="text-center p-3 text-muted">
                                            <i className="bi bi-cloud-arrow-up-fill display-5 text-primary opacity-50 mb-1 d-block"></i>
                                            <span className="small fw-semibold">Chọn hoặc kéo thả ảnh đại diện vào đây</span>
                                        </div>
                                    )}
                                </div>
                                <input
                                    type='file'
                                    className="form-control form-control-sm rounded-3"
                                    accept="image/*"
                                    onChange={(event) => handleOnchangeInput(event.target.files[0], 'faceImage')}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Bulk upload section */}
                    <div className="excel-upload-card mt-3">
                        <h6 className="fw-bold text-success mb-2 d-flex align-items-center gap-2">
                            <i className="bi bi-file-earmark-excel-fill fs-5"></i>
                            Thêm danh sách người dùng từ file Excel
                        </h6>
                        <div className="row align-items-center g-2">
                            <div className="col-md-8">
                                <input
                                    type="file"
                                    accept=".xlsx,.xls"
                                    className="form-control form-control-sm rounded-3 bg-white"
                                    ref={fileInputRef}
                                    onChange={(event) => setFileUsers(event.target.files[0])}
                                />
                                <small className="text-muted" style={{ fontSize: '11px' }}>
                                    Hỗ trợ định dạng file Excel (.xlsx, .xls)
                                </small>
                            </div>
                            <div className="col-md-4">
                                <Button
                                    variant="success"
                                    className="w-100 rounded-3 fw-semibold btn-sm py-2 d-flex align-items-center justify-content-center gap-2"
                                    onClick={handleAddListUsers}
                                    disabled={!fileUsers}
                                >
                                    <i className="bi bi-upload"></i>
                                    Tải lên danh sách
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top py-2 px-4">
                    <Button variant="outline-secondary" className="rounded-3 px-4" onClick={() => { setShowAddModal(false); setFaceIamgeAdd("") }}>
                        <i className="bi bi-x-lg me-1"></i>Hủy
                    </Button>
                    <Button variant="primary" className="rounded-3 px-4 fw-semibold" onClick={handleAddUser} disabled={isSaveDisabled}>
                        <i className="bi bi-person-plus-fill me-1"></i>Thêm người dùng
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal xóa nhiều */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Xác nhận xóa?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Bạn có chắc là muốn xóa những người dùng trên?</p>
                    <p className="text-warning"><small>Hành động này không thể hoàn tác.</small></p>
                    <p>Hãy nhập mật khẩu để xác minh bạn là quản trị viên</p>
                    <Form.Control
                        type="password"
                        value={password}
                        onChange={handlePasswordChange}
                        placeholder="Nhập mật khẩu"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className='btn' onClick={() => setShowDeleteModal(false)}>
                        Hủy
                    </Button>
                    <Button variant="danger" className='btn' type="submit" onClick={() => handleDeleteListUsers()}>
                        <i className="fas fa-trash me-2"></i>Xóa
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal xác nhận xóa một người dùng */}
            <Modal show={confirmDelete} onHide={() => setShowConfirmdelete(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
                        Xác nhận xóa
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center">
                        <i className="fas fa-user-times fa-4x text-danger mb-3"></i>
                        <h5>Bạn có chắc chắn muốn xóa người dùng?</h5>
                        <p className="text-muted">
                            Mã người dùng: <strong>{dataDetail.userCode}</strong>
                        </p>
                        <div className="alert alert-warning mt-3">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            <strong>Cảnh báo:</strong> Hành động này không thể hoàn tác.
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setShowConfirmdelete(false); setListUsersToDelete([]) }}>
                        <i className="fas fa-times me-2"></i>Hủy
                    </Button>
                    <Button variant="danger" onClick={() => handleDeleteAUser(dataDetail)}>
                        <i className="fas fa-trash me-2"></i>Xác nhận xóa
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ListClients;
